module.exports = __webpack_public_path__ + "static/img/ecf2fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/5-1.png
// module id = 625
// module chunks = 2